import clsx from "clsx";

type CardVariant = "default" | "formSection";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: CardVariant;
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  variant = "default",
}) => {
  const baseClasses = "bg-white rounded-lg";
  const variantClasses = {
    default: "shadow-lg p-5",
    formSection: "border border-gray-200 shadow-sm p-6",
  };

  return (
    <div className={clsx(baseClasses, variantClasses[variant], className)}>
      {children}
    </div>
  );
};
